export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f5b92e708fcce7a6d4e54b35e9855048047ae53d9&name=fetchTypeahead!'